
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, CheckCircle } from 'lucide-react';

const AuthTestSuite = () => {
  return (
    <Card className="bg-gray-800 border-gray-700">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-white">
          <Shield className="h-5 w-5 text-sports-green" />
          Authentication Test Suite
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Login Flow Tests</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Session Management</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Password Reset</span>
          </div>
          <p className="text-sm text-gray-400 mt-4">
            Authentication system tests are running normally.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default AuthTestSuite;
